/**
 * Client-side reading of a SeqOne analysis display name (GEN-5657).
 *
 * Mirrors the backend parser (app/cases/analysis_name.py): a display name is
 * `{OR-token}_{IN-token}_{report_config}_{ordinal}[_{ENV}]`, where report_config
 * encodes family size. We only need the declared family type here, to show a
 * "Trio analysis" style badge on the order view. This is purely informational:
 * it does NOT decide which samples load (delivery is keyed by order UUID and
 * shows every delivered member; scoping to the analysis cohort is GEN-5658).
 *
 * "proband" is the pre-GEN-4596 spelling of "singleton"; both mean one member.
 */

const ANALYSIS_NAME_RE =
  /^[A-Z]{2}-?\d+(?:-[A-Z0-9]+)?_[A-Z]{2}-?\d+(?:-[A-Z0-9]+)?_(?<config>singleton|proband|duo|trio)_\d+(?:_[A-Z0-9]+)?$/i

const FAMILY_LABELS: Record<string, string> = {
  singleton: 'Singleton analysis',
  proband: 'Singleton analysis',
  duo: 'Duo analysis',
  trio: 'Trio analysis',
}

/**
 * Return the declared family-type badge label for a token when it is a SeqOne
 * analysis display name (e.g. "Trio analysis"), or null for any other token
 * (an order HRID, a UUID, or a non-analysis string), which carries no family
 * type to show.
 */
export function analysisFamilyLabel(token: string): string | null {
  const match = ANALYSIS_NAME_RE.exec(token.trim())
  const config = match?.groups?.config?.toLowerCase()
  return config ? (FAMILY_LABELS[config] ?? null) : null
}
